export const PublicSite = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1_6319)">
<g transform="translate(1 0)">
<circle cx="21.5" cy="21.5" r="7.5" stroke="currentColor" stroke-width="2"/>
<path d="M10 24C9.33334 24 8.49918 24 6.89918 24C3.53092 24 0.0441284 21.8967 0.0441284 17.3542C0.0441284 12.9542 4.07451 11.18 6.07451 11.0133C6.40784 8.34663 8.78956 3 15 3C20.8417 3 23.7379 8.32956 23.7379 10" stroke="currentColor" stroke-width="2"/>
<path d="M22 29C22.5 28.1346 24 25.7579 24 21.7586C24 17.7593 22.75 14.8654 22 14" stroke="currentColor" stroke-width="2"/>
<path d="M21 14C20.5 14.8654 19 17.2421 19 21.2414C19 25.2407 20.25 28.1346 21 29" stroke="currentColor" stroke-width="2"/>
<path d="M13.6071 22H29.3929" stroke="currentColor" stroke-width="2"/>
</g>
</g>
<defs>
<clipPath id="clip0_1_6319">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;
